export const Categories = {
    ALL: "all",
    ELECTRONICS: "electronics",
    JEWEL: "jewelery",
    MEN: "men's clothing",
    WOMEN: "women's clothing",

};

//enum 클래스를 변경할 수 없도록 얼림
Object.freeze(Categories);